/**
 * @generated SignedSource<<1344455e3d3dc0e6661260984439af29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TikTokSoundsIncluded_tikTokSoundSelectable$data = {
  readonly thumbnailUrl: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"TikTokSoundsIncluded_tikTokSoundDetails">;
  readonly " $fragmentType": "TikTokSoundsIncluded_tikTokSoundSelectable";
};
export type TikTokSoundsIncluded_tikTokSoundSelectable$key = {
  readonly " $data"?: TikTokSoundsIncluded_tikTokSoundSelectable$data;
  readonly " $fragmentSpreads": FragmentRefs<"TikTokSoundsIncluded_tikTokSoundSelectable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TikTokSoundsIncluded_tikTokSoundSelectable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailUrl",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TikTokSoundsIncluded_tikTokSoundDetails"
    }
  ],
  "type": "TikTokSoundNode",
  "abstractKey": null
};

(node as any).hash = "96e2e27c322e3c1c1fc41bbc2e705fc4";

export default node;
